// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eadc878f","455":"90e87292","977":"a9948942"}[chunkId] + ".chunk.js";
};